<template>
    <header class="text-center mb-4">
        <h2 class="skin-page-heading">The Tax Benefits of Paying More In</h2>
    </header>

    <div class="row">
        <div class="col-md-5 mx-auto text-center">
            <p>This is coming soon with information about the tax benefits of paying into your pension pots.</p>
        </div>
    </div>
</template>
